<template>
    <div>
        <form-account-edit :userDetails="user"></form-account-edit>
    </div>
</template>
<script>
import formAccountEdit from "@/components/forms/form-account-edit.vue"
export default {
    components: {
        formAccountEdit
    }
}
</script>